module.exports = __webpack_public_path__ + "img/zhkj.4db7c585.png";